import React, { useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  ArrowUpRight,
  GraduationCap,
  Users,
  Briefcase,
  Globe,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const PlacementCompanies = () => {
  const COMPANY_LOGOS = [
    {
      src: "http://media.corporate-ir.net/media_files/IROL/17/176060/Oct18/Amazon%20logo.PNG",
      alt: "Amazon",
    },
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg",
      alt: "Infosys",
    },
    {
      src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzy2mrlHacOkxc1wMcRq_-OrgjswJs5DiSiA&s",
      alt: "TCS",
    },
    {
      src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuRKmtjAiM9SvneSbvgD2BdwI_VfXRqJ-nqA&s",
      alt: "Wipro",
    },
    {
      src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJHDw0QbI9mfJPxDJv-zDzybN_gpEiAwVrcg&s",
      alt: "Bosch",
    },
  ];

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <section style={{ padding: "2rem 1rem", overflow: "hidden" }}>
      {/* HEADER */}
      <div className="text-center mb-4 px-3">
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "6px 14px",
            background: "#EFF6FF",
            color: "#F97316",
            borderRadius: 999,
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            marginBottom: "1.2rem",
          }}
        >
          <GraduationCap size={16} />
          Placement Success
        </div>

        <h2 style={{ fontSize: "clamp(1.9rem,4.5vw,2.8rem)", fontWeight: 800 }}>
          Our students work at{" "}
          <span style={{ color: "#F97316" }}>leading companies</span>
        </h2>

        <p
          style={{
            maxWidth: 680,
            margin: "0 auto",
            fontSize: "1.05rem",
            color: "#64748B",
            fontWeight: 500,
          }}
        >
          Through our guaranteed internship & placement programs, we bridge the
          gap between education and global industry standards.
        </p>
      </div>

      {/* LOGOS */}
      <div className="logo-wrapper container">
        <button className="arrow-btn left" onClick={scrollLeft}>
          <ChevronLeft size={22} />
        </button>

        <div className="logo-marquee" ref={scrollRef}>
          {[...COMPANY_LOGOS, ...COMPANY_LOGOS].map((company, i) => (
            <div className="logo-card" key={i}>
              <img src={company.src} alt={company.alt} />
            </div>
          ))}
        </div>

        <button className="arrow-btn right" onClick={scrollRight}>
          <ChevronRight size={22} />
        </button>
      </div>

      {/* STATS */}
      <Container fluid>
        <Row className="g-3">
          {[
            { icon: <Users />, label: "Students Placed", value: "200+" },
            { icon: <Briefcase />, label: "Highest Package", value: "12 LPA" },
            { icon: <Globe />, label: "Global Partners", value: "10+" },
            { icon: <ArrowUpRight />, label: "Hiring Rate", value: "98%" },
          ].map((s, i) => (
            <Col key={i} xs={6} lg={3}>
              <div className="stat-card">
                <div className="stat-icon">
                  {React.cloneElement(s.icon, { size: 26 })}
                </div>
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* CSS */}
      <style>{`
        .logo-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .logo-marquee {
          display: flex;
          gap: 16px;
          overflow-x: auto;
          scroll-behavior: smooth;
          padding: 1rem;
        }

        .logo-marquee::-webkit-scrollbar {
          display: none;
        }

        .logo-card {
          min-width: 150px;
          background: #F8FAFC;
          border-radius: 14px;
          padding: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-card img {
          height:50px;
          max-width: 120px;
          object-fit: contain;
        }

        .arrow-btn {
          display: none;
          background: #b1aeae2e;
          color: #F97316;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          position: absolute;
          z-index: 5;
        }

        .arrow-btn.left { left: -12px; }
        .arrow-btn.right { right: -12px; }

        .stat-card {
          background: #f9f3f3ec;
          border-radius: 15px;
          padding: 1rem;
          text-align: center;
        }

        .stat-icon {
          width: 52px;
          height: 52px;
          border-radius: 16px;
          background: #b1aeae2e;
          color: #F97316;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto .75rem;
        }

        .stat-value {
          font-size: 1.7rem;
          font-weight: 900;
        }

        .stat-label {
          font-size: .7rem;
          letter-spacing: .14em;
          font-weight: 700;
          text-transform: uppercase;
          color: #64748B;
        }

        @media (max-width:768px) {
          .arrow-btn {
            display: flex;
          }
        }
      `}</style>
    </section>
  );
};

export default PlacementCompanies;